export type MobilePremiumNavAction =
  | { type: "auth"; modal: "login" }
  | { type: "subscribe"; href: "/subscription" }
  | { type: "manage" }

export function resolveMobilePremiumNavAction(input: {
  isAuthenticated: boolean
  isPaid: boolean
}): MobilePremiumNavAction {
  if (!input.isAuthenticated) return { type: "auth", modal: "login" }
  if (input.isPaid) return { type: "manage" }
  return { type: "subscribe", href: "/subscription" }
}
